import $ from 'jquery';

export default class Ajax {
    /**
     * Make an AJAX request
     * @param {String} method
     * @param {String} url
     * @param {Object} data
     * @param {Object} options
     * @return {Promise<any>}
     */
    static request(method, url, data, options = {}) {
        return new Promise((resolve, reject) => {
            $.ajax(url, {...options, method, data}).done(resolve).fail(reject);
        });
    }

    /**
     * Make an AJAX GET request
     * @param {String} url
     * @param {Object} data
     * @param {Object} options
     * @return {Promise<any>}
     */
    static get(url, data, options = {}) {
        return Ajax.request('get', url, data, options);
    }

    /**
     * Make an AJAX POST request
     * @param {String} url
     * @param {Object} data
     * @param {Object} options
     * @return {Promise<any>}
     */
    static post(url, data, options = {}) {
        return Ajax.request('post', url, data, options);
    }
}


// WEBPACK FOOTER //
// ./assets/js/Ajax.js